// extracted by mini-css-extract-plugin
module.exports = {"containerform":"todoList_containerform__1knDx","todoContainer":"todoList_todoContainer__2nsxV","btn":"todoList_btn__2F83j"};